export default __webpack_public_path__ + "static/media/thirteen.4ebf7928.jpeg";